import {  getSession } from '@/util/localStor'
export function getNations (id) {
    let nation =''
    let nationList = Object.values(getSession('nationList'))
    nationList.map((item,index)=>{
        if(item.id==id) nation=item.name
    })  
    return nation
}